import { MusicProfileResponseDTO } from '@/core/api/dtos/response/radio/musicProfile'
import {
	MusicProfile,
	MusicProfileData,
} from '@/core/api/entities/radio/musicProfile'
import { BusinessCategoryMapper } from '@/core/api/mappers/businessCategoryMapper'

export class MusicProfileMapper {
	static toEntity(data: MusicProfileResponseDTO): MusicProfile {
		return MusicProfile.create({
			id: data.id,
			accountId: data.account_id,
			businessCategoryId: data.business_category_id,
			brandIdentityIds: data.brand_identity_ids,
			name: data.name,
			data: MusicProfileData.create(data.data),

			businessCategory: data.business_category
				? BusinessCategoryMapper.toEntity(data.business_category.data)
				: undefined,
		})
	}

	static toEntities(data: MusicProfileResponseDTO[]): MusicProfile[] {
		return data.map(MusicProfileMapper.toEntity)
	}
}
